import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#8e24aa',
            secondary: '#8e24aa',
            accent: '#8e24aa',
            error: '#b71c1c',
            turquoise: '#1dcad3',
            zertuBlue: '#00B0F0'
          },
        },
      },
});
